import React, { useState } from 'react';
import Switch from '@material-ui/core/Switch';
import Paper from '@material-ui/core/Paper';
import Zoom from '@material-ui/core/Zoom';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { makeStyles } from '@material-ui/core/styles';
import { Carousel } from 'react-responsive-carousel';
// import Carousel from "./Carousel";
import useWindowPosition from '../hook/useWindowPosition';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import content from '../content';

const useStyles = makeStyles((theme) => ({
	root: {
		height: 180,
	},
	container: {
		display: 'flex',
	},
	paper: {
		margin: theme.spacing(1),
	},
}));

const Additional = () => {
	const animated = useWindowPosition('header', 0.6, 4);
	const classes = useStyles();
	const [show, setShow] = useState(false);

	const handleChange = () => {
		setShow((prev) => !prev);
	};

	return (
		<div
			className="flex justify-center items-center flex-col"
			style={{
				background: '#FEFEFE',
			}}
		>
			<FormControlLabel
				control={<Switch checked={show} onChange={handleChange} />}
				label={
					<span
						// style={{
						// 	textAlign: 'left',
						// 	marginTop: '45px',
						// 	color: 'rgb(9, 28, 41)',
						// 	fontSize: '30px',
						// 	marginBottom: '30px',
						// 	fontFamily: 'Dosis',
						// 	fontWeight: '700',
						// }}

						style={{
							textAlign: 'left',
							marginTop: '45px',
							// color: 'rgb(9, 28, 41)',
							fontSize: '30px',
							marginBottom: '30px',
							fontFamily: 'Dosis',
							fontWeight: '700',
							background: `-webkit-linear-gradient(
							  to right,
							   red,
							  #c471ed,
							  #12c2e9
							)`, /* Chrome 10-25, Safari 5.1-6 */
							background: `linear-gradient(
							  to right,
							   red,
							  #c471ed,
							  #12c2e9
							)`, /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
							'background-clip': 'text',
							'-webkit-background-clip': 'text',
							'color': 'transparent'
						  }
					  }
					>
						View Other Projects
					</span>
				}
				style={{ marginTop: '45px', marginBottom: '30px' }}
			/>

			{show ? (
				<Zoom in={show}>
					<Carousel autoPlay className="transtion duration-2000 ease-in-out z-10  md:w-3/5 w-4/5">
					<div
							style={{
								height: '365px',
								backgroundColor: 'rgb(9, 28, 41)',
								padding: '20px',
								borderRadius: '20px',
							}}
							className="font-dosis transtion duration-2000"
						>
							<h3
								style={{ color: 'white', marginTop: '10px' }}
								className={`${
									animated ? '' : 'translate-y-10 opacity-0'
								} transform transition duration-3000 text-white md:text-2xl text-l`}
							>
								{/* An application developed specially for all the faculty members of campus, through which they can book seats in the local campus bus beforehand, as they may sometimes miss the bus. */}
								Worked on a product that provides digital content monetisation solutions which engages large segment of visitors - not just subscribers.
								Developed Contribution panel and customer dashboard of the product.
							</h3>
							<p
								className={`${
									animated ? '' : 'translate-y-10 opacity-0'
								} transform transition duration-3000 text-aqua md:text-xl text-l`}
								style={{ marginTop: '20px', color: 'aqua' }}
							>
								Technologies - Reactjs, Chakra-Ui, CSS3, Javascript
							</p>
							<p className="legend" style={{ fontSize: 'large' }}>
								Anamoney
							</p>
						</div>

						<div
							style={{
								height: '365px',
								backgroundColor: 'rgb(9, 28, 41)',
								padding: '20px',
								borderRadius: '20px',
							}}
							className="font-dosis transtion duration-2000"
						>
							<p
								style={{ color: 'white', marginTop: '10px' }}
								className={`${
									animated ? '' : 'translate-y-10 opacity-0'
								} transform transition duration-3000 text-white md:text-2xl text-l`}
							>
								Created a smart cap for visually impaired citizens that will immensely help them to
								detect obstacles uptil a certain height and diameter which can prevent various accidents
								beforehand.
							</p>
							<p
								className={`${
									animated ? '' : 'translate-y-10 opacity-0'
								} transform transition duration-3000 text-aqua md:text-xl text-l`}
								style={{ marginTop: '20px', color: 'aqua' }}
							>
								Technologies - Arduino Programming
							</p>
							<p className="legend" style={{ fontSize: 'large' }}>
								Smart Cap
							</p>
						</div>
						
						<div
							style={{
								height: '365px',
								backgroundColor: 'rgb(9, 28, 41)',
								padding: '20px',
								borderRadius: '20px',
							}}
							className="font-dosis transtion duration-2000"
							// className="transtion duration-2000 ease-in-out z-10  md:w-3/5 w-4/5"
						>
							<h3
								style={{ color: 'white', marginTop: '10px' }}
								className={`${
									animated ? '' : 'translate-y-10 opacity-0'
								} transform transition duration-3000 text-white md:text-2xl text-l`}
							>
								Predicted health status and disease prediction using Machine Learning and Deep Learning
								for a live ongoing project 'CATCH SIKKIM'. Combined the model into a web application
								using Djano framework for seamless user interactivity.
							</h3>
							<p
								className={`${
									animated ? '' : 'translate-y-10 opacity-0'
								} transform transition duration-3000 text-aqua md:text-xl text-l`}
								style={{ marginTop: '20px', color: 'aqua' }}
							>
								Technologies - Machine-Learning, Deep-Learning, Tensorflow, Keras, Django
							</p>
							<p className="legend" style={{ fontSize: 'large' }}>
								ML/DL Project
							</p>
						</div>

						<div
							style={{
								height: '365px',
								backgroundColor: 'rgb(9, 28, 41)',
								padding: '20px',
								borderRadius: '20px',
							}}
							className="font-dosis transtion duration-2000"
							// className="transtion duration-2000 ease-in-out z-10  md:w-3/5 w-4/5"
						>
							<h3
								style={{ color: 'white', marginTop: '10px' }}
								className={`${
									animated ? '' : 'translate-y-10 opacity-0'
								} transform transition duration-3000 text-white md:text-2xl text-l`}
							>
								An application developed specially for all the faculty members of campus, through which
								they can book seats in the local campus bus beforehand, as they may sometimes miss the
								bus.
							</h3>
							<p
								className={`${
									animated ? '' : 'translate-y-10 opacity-0'
								} transform transition duration-3000 text-aqua md:text-xl text-l`}
								style={{ marginTop: '20px', color: 'aqua' }}
							>
								Technologies - HTML5, CSS5, Javascript, Bootstrap, Php, MySQL
							</p>
							<p className="legend" style={{ fontSize: 'large' }}>
								Online Bus-Booking
							</p>
						</div>
						<div
							style={{
								height: '365px',
								backgroundColor: 'rgb(9, 28, 41)',
								padding: '20px',
								borderRadius: '20px',
							}}
							className="font-dosis transtion duration-2000"
						>
							<h3
								style={{ color: 'white', marginTop: '10px' }}
								className={`${
									animated ? '' : 'translate-y-10 opacity-0'
								} transform transition duration-3000 text-white md:text-2xl text-l`}
							>
								The module that i have worked on is 'Analysis and Visualization of Malware Dataset'
								which is a part of 'Scalable attack data capturing and analysis framework for cyber
								threat intelligence generation'. Also i discovered several meaningful insights using
								Tableau from the dataset.
							</h3>
							<p
								className={`${
									animated ? '' : 'translate-y-10 opacity-0'
								} transform transition duration-3000 text-aqua md:text-xl text-l`}
								style={{ marginTop: '20px', color: 'aqua' }}
							>
								Technologies - Big-Data, Hadoop, Sqoop, Tableau, MySQL, HiveQL
							</p>
							<p className="legend" style={{ fontSize: 'large' }}>
								Big-Data Project
							</p>
						</div>
						<div
							style={{
								height: '365px',
								backgroundColor: 'rgb(9, 28, 41)',
								padding: '20px',
								borderRadius: '20px',
							}}
							className="font-dosis transtion duration-2000"
						>
							<h3
								style={{ color: 'white', marginTop: '10px' }}
								className={`${
									animated ? '' : 'translate-y-10 opacity-0'
								} transform transition duration-3000 text-white md:text-2xl text-l`}
							>
								{/* An application developed specially for all the faculty members of campus, through which they can book seats in the local campus bus beforehand, as they may sometimes miss the bus. */}
								Developed a software interface for performing various operations on Gene Sequence.
								Basically the application extracts gene information from a valid fasta file.
							</h3>
							<p
								className={`${
									animated ? '' : 'translate-y-10 opacity-0'
								} transform transition duration-3000 text-aqua md:text-xl text-l`}
								style={{ marginTop: '20px', color: 'aqua' }}
							>
								Technologies - HTML5, CSS3, Javascript, Bootstrap, Python, MongoDB
							</p>
							<p className="legend" style={{ fontSize: 'large' }}>
								Genome Sequence
							</p>
						</div>
						
					</Carousel>
				</Zoom>
			) : null}
		</div>
	);
};

export default Additional;
